//Test 1
import React, { useEffect, useRef, useState } from "react";
import Api from "./components/api/api";
import Loading from "./components/Loading";
import Alert from "./components/Alert";
import PreorderPopup from "./components/PreorderPopup";
import Variants from "./components/Variants";
import MonoOrderConfirm from "./components/MonoOrderConfirm";
import Lock from "./components/Lock";
import LegalPopup from "./components/LegalPopup";
import PagePopup from "./components/PagePopup";
import Pin from "./components/Pin";
import Name from "./components/Name";
import Covers from "./components/Covers";
import StaffPin from "./components/StaffPin";
import StaffTablesFrame from "./components/StaffTablesFrame";
import TabletWelcome from "./components/TabletWelcome";
import Page from "./components/Page";
import PopUps from "./components/PopUps";
import FlowPopUp from "./components/FlowPopUp";
import "./css/App.css";
import "./css/Products.css";
import "./css/ProductSheet.css";
import "./css/tempUserPopup.css";
import Lists from "./components/Lists";
import Socket from "./Socket";
import { io } from "socket.io-client";
import Label from "./components/Label";
import Cart from "./components/Cart";
import User from "./components/User";
import PromoPopup from "./components/PromoPopup";
import ProductSheet from "./components/ProductSheet";
import QrOrderConfirm from "./components/QrOrderConfirm";
import Orders from "./components/Orders";
import RelatedProductsPopup from "./components/RelatedProductsPopup";
import moment from "moment";
import Limits from "./components/Limits";
import { replaceAll, textLabel, getTranslatedString } from "./components/functions/functions";
import EmailPopup from "./components/EmailPopup";
import { GoogleOAuthProvider } from "@react-oauth/google";
import TagManager from "react-gtm-module";
import QrPopup from "./components/QrPopup";
import { jwtDecode } from "jwt-decode";
import LocalHistory from "./components/LocalHistory";
import { adaptMenuFlat } from "./menu/MenuFlatAdapter.js";

export const SettingsContext = React.createContext();
export const ShopContext = React.createContext();
export const TableContext = React.createContext();
export const CategoriesContext = React.createContext();
export const CartContext = React.createContext();
export const AlertContext = React.createContext();
export const UserContext = React.createContext();

const hostname = window.location.hostname;
let socketUrl = false;
if (hostname.includes("localhost") || hostname.includes(".dev."))
  socketUrl = "https://ws.dev.yellgo.cloud:3000";
else socketUrl = "https://ws.yellgo.cloud";
export const socket = io(socketUrl);

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const sessionScope =
    queryParams.get("shop_id") && queryParams.get("table_id")
      ? "shop-" + queryParams.get("shop_id") + "-table-" + queryParams.get("table_id")
      : queryParams.get("pin")
        ? "pin-" + queryParams.get("pin")
        : queryParams.get("shop_id")
          ? "shop-" + queryParams.get("shop_id")
          : queryParams.get("brand_id")
            ? "brand-" + queryParams.get("brand_id")
            : sessionStorage.getItem("selforder:active_scope") || "global";
  const scopedStorageKey = (key) => `selforder:${sessionScope}:${key}`;
  if (sessionScope !== "global") sessionStorage.setItem("selforder:active_scope", sessionScope);
  const getStoredCustomerId = () =>
    localStorage.getItem("self_customer_id") || localStorage.getItem("customer_id");
  const setStoredCustomerId = (customerId) => {
    localStorage.setItem("customer_id", customerId);
    localStorage.setItem("self_customer_id", customerId);
  };
  const clearStoredCustomerId = () => {
    localStorage.removeItem("customer_id");
    localStorage.removeItem("self_customer_id");
  };
  const [lock, setLock] = useState(true);
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(false);
  const [shop, setShop] = useState(false);
  const [table, setTable] = useState(false);
  const [brand, setBrand] = useState(false);
  const [pin, setPin] = useState(false);
  const [menu, setMenu] = useState([]);
  const [categories, setCategories] = useState([]);
  const [course, setCourse] = useState(false);
  const [category, setCategory] = useState(false);
  const [cart, setCart] = useState(false);
  const [alertData, setAlertData] = useState(false);
  const [monoOrder, setMonoOrder] = useState(false);
  const [user, setUser] = useState(false);
  const [userPopupVisible, setUserPopupVisible] = useState(false);
  const [listId, setListId] = useState(false);
  const [accessType, setAccessType] = useState(false);
  // modalità tablet (YELLGO-6125): proprietà della singola istanza, attivata solo da ?tablet=1
  const [tabletMode, setTabletMode] = useState(false);
  const [staff, setStaff] = useState(false);
  const [staffGateVisible, setStaffGateVisible] = useState(false);
  // benvenuto al cliente dopo la consegna del tablet da parte dell'operatore
  const [tabletWelcome, setTabletWelcome] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(false);
  const [confirmAnimation, setConfirmAnimation] = useState(false);
  const [monoOrderConfirmVisible, setMonoOrderConfirmVisible] = useState(false);
  const [qrOrderConfirmVisible, setQrOrderConfirmVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [isPaymentUser, setIsPaymentUser] = useState(false);
  const [productSheet, setProductSheet] = useState(false);
  const [userID] = useState(() => {
    const scopedUserId = localStorage.getItem(scopedStorageKey("user_id"));
    if (scopedUserId) return scopedUserId;
    if (sessionScope === "global" && localStorage.getItem("self_user_id")) {
      return localStorage.getItem("self_user_id");
    } else {
      const userID =
        Date.now() + "-" + Math.floor(Math.random() * 100) + "-" + Math.floor(Math.random() * 100);
      localStorage.setItem(scopedStorageKey("user_id"), userID);
      if (sessionScope === "global") localStorage.setItem("self_user_id", userID);
      return userID;
    }
  });
  const [legal, setLegal] = useState(false);
  const [legalPopup, setLegalPupop] = useState(false);
  const [pagePopup, setPagePopup] = useState(false);
  const [promoPopup, setPromoPopup] = useState(false);
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("lang") ? localStorage.getItem("lang") : false;
  });
  const [credit, setCredit] = useState(false);
  const [flowPopUp, setFlowPopUp] = useState(false);
  const [labels, setLabels] = useState(false);
  const [cartVisible, setCartVisible] = useState(false);
  const [discounts, setDiscounts] = useState(false);
  const [ordersVisible, setOrdersVisible] = useState(false);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState(false);
  const [popUps, setPopUps] = useState(false);
  const [preorderPopup, setPreorderPopup] = useState(false);
  const [loadRelated, setLoadRelated] = useState(true);
  const [timerActive, setTimerActive] = useState(false);
  const [emailPopupVisible, setEmailPopupVisible] = useState(false);
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [showYellgoPayPopup, setShowYellgoPayPopup] = useState(false);
  const [marketing, setMarketing] = useState(0);
  const [newsletter, setNewsletter] = useState(0);
  const [singleOrderMode, setSingleOrderMode] = useState(false);
  const [productNotesPopup, setProductNotesPopup] = useState(false);
  const [pages, setPages] = useState([]);
  const [stock, setStock] = useState([]);
  const [qrPopupVisible, setQrPopupVisible] = useState(false);
  // gruppi limite del tavolo (con quantita' usata): arrivano con il carrello da self_cart/get
  const limits = cart?.limits ?? [];
  const [localHistoryVisible, setLocalHistoryVisible] = useState(false);
  const [additionalCheckoutFields, setAdditionalCheckoutFields] = useState([]);
  const [history, setHistory] = useState(
    localStorage.getItem("selforder-history") ? JSON.parse(localStorage.getItem("selforder-history")) : [],
  );
  let timer;
  let timer_menu;

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (shop && cart) {
      if (shop.selfordering_round_time && !monoOrder) {
        check_round_time();
        timer = setInterval(check_round_time, 1000);
      }
    }
    return () => clearInterval(timer);
  }, [cart, shop.monoOrder]);

  useEffect(() => {
    localStorage.setItem("selforder-history", JSON.stringify(history));
  }, [history]);

  useEffect(() => {
    if (settings) {
      applyCustomCss();
      initLang();
      if (settings.selfordering.maintenance == 1) setIsMaintenance("maintenance");
    }
  }, [settings]);

  useEffect(() => {
    if (settings) {
      if (!getStoredCustomerId() && settings.selfordering.login_at_start == 1) setUserPopupVisible(true);
    }
  }, [user, settings]);

  useEffect(() => {
    if (settings && brand) {
      applyBrandCss();
    }
  }, [brand]);

  useEffect(() => {
    console.log("accessType set to", accessType);
  }, [accessType]);

  useEffect(() => {
    console.log("pin set to", pin);
  }, [pin]);

  useEffect(() => {
    if (menu) {
      filterMenu();
      timer_menu = setInterval(filterMenu, 60000);
    }
    return () => {
      console.log("clear timer_menu");
      clearInterval(timer_menu);
    };
  }, [menu, shop, listId, lang, settings, discounts, cart]);

  // Sconti-prodotto. Due modalita':
  // - "menu": le regole statiche arrivano con il menu (menu/courses_flat, chiave discounts_products) e solo la quantita'
  //   residua degli sconti a quantita' limitata viene letta da discounts_products/availability. Poi si aggiorna via socket
  //   (evento "discounts_products" al checkout di qualsiasi ordine) e ogni 5 minuti: nessuna richiesta a ogni modifica del carrello.
  // - "legacy": il menu in cache non ha ancora la chiave (non rigenerato dopo il rilascio): si usa discounts_products/list come prima.
  const [discountsMode, setDiscountsMode] = useState(null);
  const [discountRules, setDiscountRules] = useState([]);
  const [discountsAvail, setDiscountsAvail] = useState(null);

  // Dipende da carrello e cliente: quantita' residua (has_qty_limit) e chiusura per cliente (one_per_customer, hidden se il cliente
  // ha gia' usato lo sconto). Il server applica one_per_customer solo a un cliente identificato.
  const discountsNeedAvailability = discountRules.some(
    (rule) => rule.has_qty_limit == 1 || rule.one_per_customer == 1,
  );

  const loadDiscountsAvailability = async () => {
    const res = await Api.post("/discounts_products/availability/", {
      customer_id: user ? user.id : null,
    });
    if (res.success == 0) return;
    const avail = {};
    for (const row of res.rows) avail[row.id] = { qty: row.qty, hidden: row.hidden };
    setDiscountsAvail(avail);
  };

  // rilettura solo se servono disponibilita' (usata dal socket alla (ri)connessione)
  const needsDiscountsAvailabilityRef = useRef(false);
  needsDiscountsAvailabilityRef.current = discountsMode === "menu" && discountsNeedAvailability;
  const reloadDiscountsAvailability = () => {
    if (needsDiscountsAvailabilityRef.current) loadDiscountsAvailabilityRef.current();
  };

  // al checkout di un ordine cambia qty e, per one_per_customer, anche hidden: si rilegge la disponibilita'
  const onDiscountsProductsEvent = (data) => {
    if (!data || data.id === undefined) return;
    setDiscountsAvail((prev) => ({
      ...(prev || {}),
      [data.id]: { hidden: prev?.[data.id]?.hidden ?? 0, qty: data.qty },
    }));
    if (discountRulesRef.current.some((rule) => rule.one_per_customer == 1) && userRef.current) {
      loadDiscountsAvailabilityRef.current();
    }
  };

  const discountRulesRef = useRef([]);
  discountRulesRef.current = discountRules;
  const userRef = useRef(false);
  userRef.current = user;
  const loadDiscountsAvailabilityRef = useRef(loadDiscountsAvailability);
  loadDiscountsAvailabilityRef.current = loadDiscountsAvailability;

  useEffect(() => {
    if (discountsMode !== "menu") return;
    if (!discountsNeedAvailability) return;
    loadDiscountsAvailability();
    const interval = setInterval(loadDiscountsAvailability, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [discountsMode, discountRules, user?.id]);

  useEffect(() => {
    if (discountsMode !== "menu") return;
    const rows = [];
    for (const rule of discountRules) {
      // sconto una tantum per cliente: senza cliente identificato il server non lo applica, quindi non lo mostriamo
      if (rule.one_per_customer == 1 && !user) continue;
      const needsAvail = rule.has_qty_limit == 1 || rule.one_per_customer == 1;
      // finche' la disponibilita' non e' arrivata, gli sconti che ne dipendono non si applicano
      if (needsAvail && discountsAvail === null) continue;
      const avail = discountsAvail ? discountsAvail[rule.id] : null;
      if (avail && avail.hidden == 1) continue;
      rows.push({ ...rule, qty: rule.has_qty_limit == 1 ? (avail ? avail.qty : 0) : null });
    }
    setDiscounts(rows);
  }, [discountsMode, discountRules, discountsAvail, user?.id]);

  // --- modalita' legacy (solo se il menu non contiene le regole) ---
  // La lista non dipende dal carrello (nessun parametro, la quantita' gia' nel carrello e' calcolata in locale): si carica quando
  // il carrello e' disponibile e poi ogni 5 minuti; si rilegge a ogni modifica del carrello solo se c'e' uno sconto a quantita' limitata
  // (qty scalata al checkout di qualsiasi ordine).
  const hasCart = !!cart;
  const hasQtyLimitedDiscounts =
    Array.isArray(discounts) && discounts.some((d) => d.qty !== null && d.qty !== undefined && d.qty !== "");
  const hasQtyLimitedDiscountsRef = useRef(false);
  hasQtyLimitedDiscountsRef.current = hasQtyLimitedDiscounts;
  const loadDiscountsTimerRef = useRef(null);

  useEffect(() => {
    if (!hasCart || discountsMode !== "legacy") return;
    loadDiscounts();
    const interval = setInterval(loadDiscounts, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [hasCart, discountsMode]);

  useEffect(() => {
    if (!cart || discountsMode !== "legacy" || !hasQtyLimitedDiscountsRef.current) return;
    if (loadDiscountsTimerRef.current) return;
    loadDiscountsTimerRef.current = setTimeout(() => {
      loadDiscountsTimerRef.current = null;
      loadDiscounts();
    }, 300);
    return () => {
      clearTimeout(loadDiscountsTimerRef.current);
      loadDiscountsTimerRef.current = null;
    };
  }, [cart]);

  useEffect(() => {
    if (settings && categories && pin) {
      if (!course && !category && settings.selfordering.hide_home == 1) {
        if (categories.length > 0 && categories[0].categories.length > 0) {
          console.log("AAA", course, category, settings.selfordering.hide_home);
          setCourse(categories[0]);
          setCategory(categories[0].categories[0]);
        }
      }
      if (!course && categories.length > 0 && categories.length === 1) {
        setCourse(categories[0]);
      }
      if (course) {
        console.log("update selected");
        const courseExist = categories.find((c) => c.id == course.id);
        if (courseExist) {
          setCourse(courseExist);
          if (category) {
            const categoryExist = courseExist.categories.find((c) => c.id == category.id);
            if (!categoryExist) setCategory(courseExist.categories[0]);
            else setCategory(categoryExist);
          }
        } else setDefaultCourse();
      }
    }
  }, [categories, settings, pin]);

  useEffect(() => {
    console.log("course set to", course);
  }, [course]);

  useEffect(() => {
    console.log("category set to", category);
  }, [category]);

  useEffect(() => {
    if (shop && table && pin) {
      loadCart();
    }
  }, [shop, table, pin, lang, user, isPaymentUser, credit, settings]);

  useEffect(() => {
    console.log("cart or menu changed");
    if (menu && table?.id && pin) loadCart();
  }, [menu]);

  useEffect(() => {
    if (shop) loadPopUps();
  }, [shop, monoOrder]);

  async function loadPopUps() {
    const response = await Api.post("/popups/list/", {
      orderby: "position",
      src: [
        { name: "active", value: 1, compare: "equal" },
        { name: monoOrder ? "selforder_mono" : "selforder", value: 1, compare: "equal" },
      ],
    });
    if (response.success === 0) alert(response.error);
    else
      setPopUps(
        response.rows.filter((p) => !p.shops || p.shops.length == 0 || p.shops.find((s) => s.id == shop.id))
      );
  }

  const checkPreorderPopups = (onProceed) => {
    const queue = (popUps || []).filter(
      (p) =>
        p.type == "popup_preorder" &&
        (!p.shops || p.shops.length == 0 || p.shops.find((s) => s.id == shop.id))
    );
    showNextPreorderPopup(queue, onProceed);
  };

  const showNextPreorderPopup = (queue, onProceed) => {
    if (queue.length == 0) {
      setPreorderPopup(false);
      onProceed();
      return;
    }
    const [popup, ...rest] = queue;
    setPreorderPopup({
      popup,
      onConfirm: () => showNextPreorderPopup(rest, onProceed),
      onCancel: () => setPreorderPopup(false),
    });
  };

  useEffect(() => {
    if (confirmAnimation)
      setTimeout(function () {
        setConfirmAnimation(false);
      }, 1000);
  }, [confirmAnimation]);

  useEffect(() => {
    console.log("lang set to", lang);
    if (lang) document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    console.log("loadRelated set to", loadRelated);
  }, [loadRelated]);

  useEffect(() => {
    if (table) setSingleOrderMode(table.single_order_mode == 1);
  }, [table]);

  useEffect(() => {
    console.log("singleOrderMode set to", singleOrderMode);
  }, [singleOrderMode]);

  useEffect(() => {
    if (monoOrder && shop && settings) {
      if (settings.selfordering.force_login == 1) {
        resume_temp_cart(shop.id).then((restored) => {
          if (!restored) open_temp_cart(shop.id);
        });
      }
    }
  }, [monoOrder, shop, settings]);

  async function init() {
    console.log("init");

    Api.setBaseUrl();
    const temp_settings = await loadSettings();
    await loadLabels();
    await load_legal();
    await loadPages();
    await loadProductsStock();
    await loadAdditionalCheckoutFields();

    const shopID = await getShopId();
    const tableID = queryParams.get("table_id");
    const monoOrderParam = queryParams.get("mono_order");
    const customerID = queryParams.get("customer_id");
    const token = queryParams.get("token");
    const showConfirm = queryParams.get("show_confirm");
    const initPin = queryParams.get("pin");
    let brandID = queryParams.get("brand_id");
    const initFunction = queryParams.get("f");
    const orderId = queryParams.get("order_id");

    if (showConfirm == 1) {
      if (monoOrderParam) {
        setMonoOrderConfirmVisible({ id: orderId });
      } else if (orderId) setQrOrderConfirmVisible({ id: orderId });
      else {
        setAlertData({
          message: <Label number={48} />,
          confirmMessage: <Label number={31} />,
        });
      }
    }

    if (initFunction == "new_password") {
      setUserPopupVisible({ id: queryParams.get("id"), step: 6 });
    }

    let shop;
    if (shopID) shop = await load_shop(shopID);
    if (monoOrderParam) {
      setAccessType("mono");
      setMonoOrder(true);
      localStorage.removeItem(scopedStorageKey("pin"));
    } else if (shopID && queryParams.get("tablet") == 1) {
      // il tavolo lo sceglie l'operatore con il suo PIN; accessType resta "shop" per il resto del flusso
      setAccessType("shop");
      setTabletMode(true);
      const storedTableId = localStorage.getItem(scopedStorageKey("tablet_table"));
      if (storedTableId) {
        const storedTable = await load_table(storedTableId);
        if (storedTable && storedTable.status != 0 && storedTable.single_order_mode != 1) setPin("not_required");
        else {
          localStorage.removeItem(scopedStorageKey("tablet_table"));
          setTable(false);
        }
      }
    } else if (shopID && tableID) {
      setAccessType("shop");
      let table = await load_table(tableID);
      if (table.single_order_mode == 1) {
        const openResponse = await Api.post("/self_cart/open/" + tableID + "/");
        if (openResponse.success === 0)
          setAlertData({
            title: <Label number={70} />,
            message: openResponse.error,
            confirmMessage: <Label number={31} />,
          });
        else {
          setPin("not_required");
        }
      } else {
        if (initPin) localStorage.setItem(scopedStorageKey("pin"), initPin);
        await checkPin(temp_settings, shop, table);
      }
    } else {
      setAccessType("table");
      if (initPin) localStorage.setItem(scopedStorageKey("pin"), initPin);
      await checkPin(temp_settings);
    }

    if (token) await load_customer_by_token(token);
    else if (localStorage.getItem("selforder-token"))
      await load_customer_by_token(localStorage.getItem("selforder-token"));

    if (customerID && Api.getToken()) await load_customer(customerID);
    else if (getStoredCustomerId() && Api.getToken()) await load_customer(getStoredCustomerId());
    else if (!Api.getToken()) clearStoredCustomerId();

    if (!brandID && shopID) brandID = await getDefaultBrand(shopID, temp_settings);
    if (brandID) await load_brand(brandID);

    await load_menu();

    if (temp_settings.selfordering.googletagmanager) {
      console.log("Init Tag Manager");
      const tagManagerArgs = {
        gtmId: temp_settings.selfordering.googletagmanager,
      };
      TagManager.initialize(tagManagerArgs);
    }

    setLock(false);
  }

  const getShopId = async () => {
    if (queryParams.get("shop_id")) return queryParams.get("shop_id");
    else if (queryParams.get("brand_id")) {
      const brand = await Api.post("/brands/get/" + queryParams.get("brand_id") + "/");
      if (brand.success == 0) alert(brand.error);
      else {
        if (brand.data.shops.length > 0) return brand.data.shops[0].id;
      }
    }
  };

  const initLang = () => {
    if (queryParams.get("lang")) localStorage.setItem("lang", queryParams.get("lang"));
    const storedLang = localStorage.getItem("lang");
    const browserLang = window.navigator.userLanguage || window.navigator.language;
    console.log("initLang", storedLang, browserLang);
    console.log(window.navigator);
    if (settings.selfordering.multilanguage == 0) setLang("it");
    else {
      if (!lang || settings.global[lang] == 0) {
        if (settings.global.it == 1 && browserLang == "it-IT") setLang("it");
        else if (settings.global.zh == 1 && browserLang == "zh-CN") setLang("zh");
        else if (settings.global.en == 1) setLang("en");
        else if (settings.global.zh == 1) setLang("zh");
        else setLang("it");
      }
    }
  };

  async function loadSettings() {
    console.log("loadSettings");
    const response = await Api.post("/settings2/get/", {
      section: [
        "global",
        "selfordering",
        "google",
        "fidelity",
        "customers",
        "orders",
        "menu",
        "credit",
        "menu_api",
      ],
    });
    setSettings(response.data);

    document.title = "Selforder | " + response.data.global.name;
    var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = response.data.selfordering.favicon;
    document.getElementsByTagName("head")[0].appendChild(link);

    return response.data;
  }

  const loadLabels = async () => {
    console.log("loadLabels");
    const response = await Api.post("/labels/list/", {
      type: "selforder",
    });
    setLabels(response.rows);
  };

  const loadPages = async () => {
    console.log("loadLabels");
    const response = await Api.post("/pages/list/", {
      src: [{ name: "selforder", compare: "equal", value: 1 }],
    });
    setPages(response.rows);
  };

  const loadDiscounts = async () => {
    console.log("loadDiscounts");
    const res = await Api.post("/discounts_products/list/");
    if (res.success == 0) alert(res.error);
    else setDiscounts(res.rows);
  };

  async function loadProductsStock() {
    const response = await Api.post("/products_stock/list_for_clients/");
    if (response.success == 0) alert(response.error);
    else setStock(response.rows);
  }

  async function load_legal() {
    console.log("load_legal");
    const response = await Api.post("/legal/get/");
    if (response.success === 0) alert(response.error);
    setLegal(response.data);
  }

  async function loadAdditionalCheckoutFields() {
    console.log("load_additional_checkout_fields");
    const response = await Api.post("/additional_checkout_fields/list/");
    if (response.success === 0) alert(response.error);
    setAdditionalCheckoutFields(response.rows);
  }

  async function load_shop(shopID) {
    console.log("load_shop");
    setLoading(true);
    const response = await Api.post("/shops/get/" + shopID + "/");
    setLoading(false);
    if (response.success === 0) alert(response.error);
    setShop(response.data);
    return response.data;
  }

  async function load_table(tableID) {
    console.log("load_table");
    const response = await Api.post("/tables/get/" + tableID + "/");
    if (response.success === 0) alert(response.error);
    setTable(response.data);
    return response.data;
  }

  const checkPin = async (tempSettings, shop = false, table = false) => {
    console.log("checkPin(" + tempSettings.selfordering.pin_mode + ")");
    const p = localStorage.getItem(scopedStorageKey("pin"));
    if (p) {
      if (tempSettings.selfordering.pin_mode == "disabled") {
        if (p == "not_required") setPin("not_required");
      }
      if (
        tempSettings.selfordering.pin_mode == "generated" ||
        tempSettings.selfordering.pin_mode == "fixed"
      ) {
        const response = await Api.post("/self_cart/check_pin/", {
          pin: p,
          lang: lang,
        });
        if (response.success === 0) localStorage.removeItem(scopedStorageKey("pin"));
        else {
          if (table && table.id != response.data.id) localStorage.removeItem(scopedStorageKey("pin"));
          else {
            load_shop(response.data.shop_id);
            load_table(response.data.id);
            setPin(p);
            localStorage.setItem(scopedStorageKey("pin"), p);
          }
        }
      }
      if (tempSettings.selfordering.pin_mode == "shop") {
        if (parseInt(shop.selfordering_pin) == parseInt(p)) {
          setPin(p);
        } else {
          localStorage.removeItem(scopedStorageKey("pin"));
        }
      }
    }
  };

  async function load_brand(brandID) {
    console.log("load_brand");
    const response = await Api.post("/brands/get/" + brandID + "/");
    if (response.success === 0) alert(response.error);
    setBrand(response.data);
    localStorage.setItem("brand_id", brandID);
  }

  async function load_customer(customerID) {
    console.log("load_customer");
    const response = await Api.getProtected("/customers/get/" + customerID + "/");
    if (response.success === 0) {
      clearStoredCustomerId();
      alert(response.error);
    } else {
      setUser(response.data);
      setStoredCustomerId(response.data.id);
    }
  }

  async function load_customer_by_token(token) {
    console.log("load_customer_by_token");
    const refresh = await Api.refreshToken(token);
    if (refresh.success === 0) {
      localStorage.removeItem("selforder-token");
      clearStoredCustomerId();
      Api.setToken(null);
      alert(refresh.error);
    } else {
      const decoded = jwtDecode(refresh.token);
      console.log("decoded", decoded);
      const response = await Api.getProtected("/customers/get/" + decoded.user_id + "/");
      if (response.success === 0) {
        localStorage.removeItem("selforder-token");
        clearStoredCustomerId();
        Api.setToken(null);
        alert(response.error);
        return;
      }
      setUser(response.data);
      localStorage.setItem("selforder-token", refresh.token);
      setStoredCustomerId(response.data.id);
    }
  }

  const load_menu = async () => {
    console.log("load_menu");
    const response = await Api.get("/menu/courses_flat/");
    if (response.success === 0 || !response.data) {
      alert(response.error || "Errore nel caricamento del menu");
      return;
    }

    try {
      const adaptedMenu = adaptMenuFlat(response);
      setMenu(adaptedMenu.menu);
    } catch (error) {
      console.error("menu_flat adapt failed", error);
      alert("Errore nel parsing del menu");
    }

    // sconti-prodotto: dal menu se presenti, altrimenti dalla vecchia lista (menu in cache non ancora rigenerato)
    if (Array.isArray(response.data.discounts_products)) {
      setDiscountRules(response.data.discounts_products);
      setDiscountsMode("menu");
    } else {
      setDiscountsMode("legacy");
      loadDiscounts();
    }
  };

  function filterMenu() {
    console.log("filterMenu", lang);
    let res = [];
    for (const course of menu) {
      let cr = JSON.parse(JSON.stringify(course));
      cr = getTranslations(cr, ["name"]);
      cr.categories = [];
      for (const category of course.categories) {
        if (
          checkCategoryTimes(category) &&
          (!category.hasOwnProperty("active_selfordering") || category.active_selfordering == 1)
        ) {
          let ct = JSON.parse(JSON.stringify(category));
          ct = getTranslations(ct, ["name", "description"]);
          ct = getTagsTranslations(ct);
          ct.products = [];
          for (const product of category.products) {
            if (!product.hasOwnProperty("active_selfordering") || product.active_selfordering == 1) {
              let p = filterVariants(product);
              p = getTranslations(p, ["name", "description"]);
              p = getIngredientsTranslations(p, ["name", "description"]);
              p = getTagsTranslations(p);
              p = getLimitGroupsTranslations(p);
              p.stock = getProductStock(p.id);
              if (isOutOfStock(p)) continue;
              if (shop && listId) {
                const priceList = product.prices.filter((el) => {
                  return el.list_id == listId && el.price;
                });
                const assortment = product.assortment.filter((el) => {
                  return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
                });
                if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(product)) {
                  p.price = priceList[0].price;
                  ct.products.push(p);
                }
              } else if (shop) {
                if (checkIngredientsAssortment(product)) {
                  ct.products.push(p);
                }
              } else {
                ct.products.push(p);
              }
            }
          }
          if (ct.products.length > 0) cr.categories.push(ct);
        }
      }
      if (cr.categories.length > 0) res.push(cr);
    }
    applyDiscounts(res);
    res = generatePromoCategory(res);
    setCategories(res);
  }

  const filterVariants = (product) => {
    const normalizeOrigins = (originsRaw) => {
      if (Array.isArray(originsRaw))
        return originsRaw
          .map((origin) =>
            String(origin || "")
              .trim()
              .toLowerCase(),
          )
          .filter(Boolean);
      if (typeof originsRaw === "string")
        return originsRaw
          .split(",")
          .map((origin) =>
            String(origin || "")
              .trim()
              .toLowerCase(),
          )
          .filter(Boolean);
      return [];
    };

    const isVariantCategoryEnabledForSelforder = (variantsCategory) => {
      const origins = normalizeOrigins(variantsCategory?.origins);
      if (origins.length === 0) return true;
      return origins.includes("selfordering") || origins.includes("selforder");
    };

    let p = JSON.parse(JSON.stringify(product));
    p.variants_categories = [];
    for (const variants_category of product.variants_categories) {
      if (!isVariantCategoryEnabledForSelforder(variants_category)) continue;
      //console.groupCollapsed(variants_category.name);
      let vc = JSON.parse(JSON.stringify(variants_category));
      vc = getTranslations(vc, ["name"]);
      vc.variants = [];
      vc.variants2 = [];
      vc.products = [];
      vc.products2 = [];
      for (const variant of variants_category.variants || []) {
        //console.log(variant.name);
        let v = JSON.parse(JSON.stringify(variant));
        v = getTranslations(v, ["name"]);
        if (shop && listId) {
          const priceList = variant.prices.filter((el) => {
            /*console.log(
							variant.name,
							el.list_id,
							listId,
							el.list_id == listId,
							el.price
						);*/
            return el.list_id == listId && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
          });
          //console.log(priceList.length, assortment.length);
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = priceList[0].price;
            vc.variants.push(v);
          }
        } else {
          vc.variants.push(v);
        }
      }
      for (const variant of variants_category.variants2 || []) {
        let v = JSON.parse(JSON.stringify(variant));
        v = getTranslations(v, ["name"]);
        if (shop && listId) {
          const priceList = variant.prices.filter((el) => {
            /*console.log(
							variant.name,
							el.list_id,
							listId,
							el.list_id == listId,
							el.price
						);*/
            return el.list_id == listId && el.price !== null;
          });
          const assortment = variant.assortment.filter((el) => {
            return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
          });
          if (priceList.length > 0 && assortment.length > 0) {
            v.price = priceList[0].price;
            vc.variants2.push(v);
          }
        } else {
          vc.variants2.push(v);
        }
      }
      for (const variant of [...(variants_category.products || []), ...(variants_category.products2 || [])]) {
        //console.log(variant.name);
        let v = JSON.parse(JSON.stringify(variant));
        v = getTranslations(v, ["name", "description"]);
        if (shop && listId) {
          const priceList = variant.prices.filter((el) => {
            return el.list_id == listId && el.price !== null;
          });
          const assortment = variant.assortment?.filter((el) => {
            return el.shop_id == shop.id && el.list_id == listId && el.active == 1;
          });
          //console.log(priceList.length);
          if (priceList.length > 0 && assortment.length > 0 && checkIngredientsAssortment(variant)) {
            v.price = priceList[0].price;
            vc.products.push(v);
          }
        } else if (shop) {
          if (checkIngredientsAssortment(variant)) {
            vc.products.push(v);
          }
        } else {
          vc.products.push(v);
        }
      }
      if (vc.force_mono == 1) {
        vc.min = 0;
        vc.max = vc.variants.length + vc.variants2.length + vc.products.length;
      }
      if (vc.variants.length > 0 || vc.variants2.length > 0 || vc.products.length > 0)
        p.variants_categories.push(vc);
      //console.groupEnd();
    }
    return p;
  };

  const getProductStock = (productId) => {
    if (!stock) return false;
    const s = stock.find((e) => e.shop_id == shop.id && e.product_id == productId);
    if (s) return s.qty;
    return false;
  };

  const isStockCheckEnabled = () => {
    return settings?.menu_api?.disable_stock_check_customers != 1;
  };

  const isOutOfStock = (product) => {
    if (!isStockCheckEnabled()) return false;
    if (product.stock === false) return false;
    const stockValue = parseInt(product.stock, 10);
    if (!Number.isFinite(stockValue)) return false;
    return stockValue <= 0;
  };

  const getCartQtyForProduct = (productId) => {
    if (!cart || !cart.products) return 0;
    let total = 0;
    const seenItemIds = new Set();
    for (const item of cart.products) {
      if (item.product_id != productId) continue;
      if (seenItemIds.has(item.item_id)) continue;
      seenItemIds.add(item.item_id);
      total += parseInt(item.qty_unsplitted ?? item.qty);
    }
    return total;
  };

  const applyDiscounts = (courses) => {
    //console.log("applyDiscount");
    for (const course of courses) {
      for (const category of course.categories) {
        for (const product of category.products) {
          if (discounts && discounts.length > 0 && shop.id) {
            for (const discount of discounts) {
              if (product.id == discount.product_id) {
                const normalizeIds = (ids) => {
                  if (Array.isArray(ids)) return ids.map((id) => String(id));
                  if (typeof ids === "string")
                    return ids
                      .split(",")
                      .map((id) => String(id).trim())
                      .filter(Boolean);
                  return [];
                };
                const discountShopIds = normalizeIds(discount.shops_ids);
                const discountListIds = normalizeIds(discount.lists_ids);
                const currentShopId = String(shop.id);
                const currentListId = listId ? String(listId) : null;
                const hasQtyLimit = discount.qty !== null && discount.qty !== undefined && discount.qty !== "";
                const effectiveQtyLimit = hasQtyLimit
                  ? Number(discount.qty)
                  : discount.one_per_customer == 1
                  ? 1
                  : null;
                if (
                  (discountShopIds.length == 0 || discountShopIds.includes(currentShopId)) &&
                  (discountListIds.length == 0 || (currentListId && discountListIds.includes(currentListId))) &&
                  (!discount.date_start || moment().startOf("day") >= moment(discount.date_start)) &&
                  (!discount.date_end || moment().startOf("day") <= moment(discount.date_end)) &&
                  (effectiveQtyLimit === null || effectiveQtyLimit - getCartQtyForProduct(product.id) > 0)
                ) {
                  product.discounted = true;
                  product.discount = {
                    category: "discounts_products",
                    one_per_customer: discount.one_per_customer,
                    type: discount.type,
                    value: discount.value,
                    // il prezzo scontato non puo' andare sotto zero (sconto fisso maggiore del prezzo)
                    price: Math.max(
                      0,
                      discount.type == "perc"
                        ? product.price - (product.price / 100) * discount.value
                        : product.price - discount.value
                    ),
                  };
                  // vale la prima regola valida (come sul server): le successive non la sovrascrivono
                  break;
                }
              }
            }
          } else {
            product.discounted = false;
            product.discount = null;
          }
        }
      }
    }
  };

  const generatePromoCategory = (courses) => {
    const discountedProductsById = new Map();
    for (const course of courses) {
      for (const category of course.categories) {
        for (const product of category.products) {
          if (
            product.discounted &&
            product.discount.one_per_customer == 1 &&
            !discountedProductsById.has(product.id)
          ) {
            discountedProductsById.set(product.id, product);
          }
        }
      }
    }
    const discountedProducts = Array.from(discountedProductsById.values());
    if (discountedProducts.length > 0) {
      const promoLabel = textLabel(labels, 110, lang) || "Promo";
      courses.unshift({
        id: -2,
        name: promoLabel,
        categories: [
          {
            id: -2,
            name: promoLabel,
            description: "",
            tags: [],
            products: discountedProducts,
          },
        ],
      });
    }
    return courses;
  };

  const checkIngredientsAssortment = (product) => {
    if (!settings.menu_api) return true;
    if (!settings.menu_api.enable_ingredients_assortment) return true;
    if (settings.menu_api.enable_ingredients_assortment != 1) return true;
    if (!product.ingredients) return true;
    if (product.ingredients.length == 0) return true;
    for (const ingredient of product.ingredients) {
      const assortment = ingredient.assortment.filter((el) => {
        return el.shop_id == shop.id && el.active == 1;
      });
      if (assortment.length == 0) return false;
    }
    return true;
  };

  const checkCategoryTimes = (category) => {
    if ((settings.menu_api?.enable_categories_times ?? settings.orders?.enable_categories_times ?? 0) == 0)
      return true;

    const d = new Date();
    let day = d.getDay();
    day = day - 1;
    if (day < 0) day = 6;
    if (category.times != null) {
      let times = category.times[day];
      let enabled = false;

      let now = d.getHours() * 100 + d.getMinutes();
      for (let service = 1; service <= 2; service++) {
        let open_h = times["s" + service].open.h;
        let open_m = times["s" + service].open.m;
        let close_h = times["s" + service].close.h;
        let close_m = times["s" + service].close.m;

        if (open_h != "" && close_h != "") {
          if (parseInt(close_h) === 0) {
            const openIsMidnight = parseInt(open_h) === 0 && parseInt(open_m) === 0;
            if (!openIsMidnight || parseInt(close_m) === 0) {
              close_h = 24;
              close_m = 0;
            }
          }
          if (parseInt(close_h) < parseInt(open_h)) {
            close_h = 24;
            close_m = 0;
          }
          open_h = open_h * 100;
          close_h = close_h * 100;
          let t_open = open_h + parseInt(open_m);
          let t_close = close_h + parseInt(close_m);
          if (now >= t_open && now <= t_close) enabled = true;
          console.log(category.name, service, now, t_open, t_close);
        }
      }
      if (enabled) return true;
    }
    return false;
  };

  const setCategoryHandler = async (cr, cat) => {
    console.log("setCategoryHandler");
    setCourse(cr);
    setCategory(cat);
    if (settings.selfordering.products_loading_type == "onepage") {
      if (course && category) {
        console.log("scroll A");
        const element = document.getElementById("category-" + cat.id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        console.log("scroll B");
        setTimeout(function () {
          const element = document.getElementById("category-" + cat.id);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    }
  };

  const getTranslations = (el, fields = ["name"]) => {
    for (const field of fields) {
      if (el.translations && lang == "en")
        el[field] = el.translations.en[field] ? el.translations.en[field] : el.translations.it[field];
      if (el.translations && lang == "fr")
        el[field] =
          el.translations.fr && el.translations.fr[field]
            ? el.translations.fr[field]
            : el.translations.it[field];
      if (el.translations && lang == "zh")
        el[field] =
          el.translations.zh && el.translations.zh[field]
            ? el.translations.zh[field]
            : el.translations.it[field];
      if (el.translations && lang == "es")
        el[field] =
          el.translations.es && el.translations.es[field]
            ? el.translations.es[field]
            : el.translations.it[field];
      if (el.translations && lang == "de")
        el[field] =
          el.translations.de && el.translations.de[field]
            ? el.translations.de[field]
            : el.translations.it[field];
    }
    return el;
  };

  const getIngredientsTranslations = (product) => {
    let p = JSON.parse(JSON.stringify(product));
    p.ingredients = [];
    for (const ingredient of product.ingredients) {
      let i = JSON.parse(JSON.stringify(ingredient));
      i = getTranslations(i, ["name"]);
      p.ingredients.push(i);
    }
    return p;
  };

  const getTagsTranslations = (item) => {
    let p = JSON.parse(JSON.stringify(item));
    p.tags = [];
    if (item.tags) {
      for (const tag of item.tags) {
        let i = JSON.parse(JSON.stringify(tag));
        i = getTranslations(i, ["name"]);
        p.tags.push(i);
      }
    }
    return p;
  };

  const getLimitGroupsTranslations = (product) => {
    let p = JSON.parse(JSON.stringify(product));
    p.limit_groups = [];
    if (product.limit_groups) {
      for (const limit_group of product.limit_groups) {
        if (limit_group) {
          let i = JSON.parse(JSON.stringify(limit_group));
          i = getTranslations(i, ["name"]);
          p.limit_groups.push(i);
        }
      }
    }
    return p;
  };

  const loadCart = async () => {
    if (!table?.id) return;
    console.log("loadCart", user.id);
    const response = await Api.post("/self_cart/get/" + table.id + "/", {
      mono_order: monoOrder,
      lang: lang,
      customer_id: user.id,
      shop_id: shop.id,
      user_id: userID,
      brand_id: brand ? brand.id : "",
      credit: credit,
    });
    setLoading(false);
    if (response.success == 1) {
      setCart(response);
      if (response.lock == 1) {
        if (!isPaymentUser) setIsClosed("Invio ordine in corso");
        else setIsClosed(false);
      } else setIsClosed(false);
      if (pin) {
        if (response.status == 0 && tabletMode) {
          // tavolo chiuso (es. in cassa): il tablet torna alla schermata PIN operatore
          tabletReset();
          return response;
        }
        if (response.status == 0) {
          console.log(accessType);
          localStorage.removeItem(scopedStorageKey("pin"));
          setPin(false);
          if (accessType == "table") {
            localStorage.removeItem("shop_id");
            localStorage.removeItem("table_id");
            setShop(false);
            setTable(false);
          }
          setAlertData({
            message: response.status == 2 ? <Label number={62} /> : <Label number={63} />,
            confirmMessage: <Label number={31} />,
          });
        } else if (response.status == 2) {
          setIsClosed("Tavolo in attesa di pagamento");
        } else {
          setListId(response.list_id);
        }
      }
      return response;
    }
  };

  const checkProductsStockForCustomers = async () => {
    console.log("checkProductsStockForCustomers");
    const products = Array.isArray(cart?.products)
      ? cart.products.map((product) => ({
          product_id: product.product_id,
          qty: product.qty,
        }))
      : [];
    if (products.length === 0) return true;
    const response = await Api.post("/cart_validation/validate_products/", {
      origin: "selfordering",
      shop_id: shop.id,
      list_id: listId || cart?.list_id || "",
      lang: lang,
      products: products,
    });
    if (!response || response.success == 0) {
      setAlertData({
        message: response?.error || "Errore verifica disponibilità prodotti",
        confirmMessage: <Label number={31} />,
      });
      return { ok: false, errors: [] };
    }
    if (response.valid !== 1) {
      return { ok: false, errors: response?.errors || [] };
    }
    return { ok: true, errors: [] };
  };

  const getCleanupInvalidProductsPrompt = () => {
    const messages = {
      it: "Vuoi aggiornare il carrello rimuovendo i prodotti non piu disponibili?",
      en: "Do you want to update the cart by removing unavailable products?",
      es: "Quieres actualizar el carrito eliminando los productos no disponibles?",
      fr: "Voulez-vous mettre a jour le panier en supprimant les produits non disponibles ?",
      de: "Mochtest du den Warenkorb aktualisieren und nicht verfugbare Produkte entfernen?",
      zh: "是否更新购物车并移除不可用商品？",
    };
    return messages[lang] || messages.it;
  };

  const buildCleanupMessage = (errors) => {
    const prompt = getCleanupInvalidProductsPrompt();
    if (!errors || errors.length === 0) return prompt;
    const list = errors.map((e) => "• " + e.error).join("\n");
    return list + "\n\n" + prompt;
  };

  const cleanupInvalidCartProducts = async () => {
    if (!table?.id) return false;
    setLoading(true);
    try {
      const response = await Api.post("/self_cart/cleanup_invalid_products/" + table.id + "/", {
        mono_order: monoOrder,
        lang: lang,
      });
      if (!response || response.success === 0) {
        setAlertData({
          message: response?.error || "Errore aggiornamento carrello",
          confirmMessage: <Label number={31} />,
        });
        return false;
      }
      await loadCart();
      return true;
    } finally {
      setLoading(false);
    }
  };

  const editCart = async (request, useLoading = false, forceRefresh = false) => {
    console.log("editCart");
    if (useLoading) setLoading(true);
    try {
      const response = await Api.post("/self_cart/edit/" + table.id + "/", request);
      if (response.success === 0)
        setAlertData({
          message: response.error,
          confirmMessage: <Label number={31} />,
        });
      else if (forceRefresh || !socket.connected) await loadCart();
    } finally {
      if (useLoading) setLoading(false);
    }
  };

  const editTable = async (request, useLoading = false, forceRefresh = false) => {
    console.log("editTable");
    if (useLoading) setLoading(true);
    try {
      const response = await Api.post("/tables/edit/" + table.id + "/", request);
      if (response.success === 0)
        setAlertData({
          message: response.error,
          confirmMessage: <Label number={31} />,
        });
      else if (forceRefresh || !socket.connected) {
        if (table) await load_table(table.id);
        await loadCart();
      }
    } finally {
      if (useLoading) setLoading(false);
    }
  };

  const handleAddProduct = async (product) => {
    if (isStockCheckEnabled() && product.stock !== false && (product.stock == 0 || !checkCartQty(product))) {
      setAlertData({
        message: "Prodotto esaurito",
        confirmMessage: <Label number={57} />,
      });
      return;
    }
    add_product({
      product_id: product.id,
      qty: product.qty,
      variants: product.variants,
      products: product.products,
      notes: product.notes,
      has_price: (product.discounted ? product.discount.price : product.price) > 0 ? 1 : 0,
    });
  };

  const add_product = async (request, skip_alert = false) => {
    console.log("add_product", user.id, request);
    const enableFlow = settings?.orders?.enable_flow ?? settings?.selfordering?.enable_flow;
    if (enableFlow == 1 && !request.flow) {
      setFlowPopUp(request);
      setSelectedProduct(false);
      return;
    }
    if (
      cart.allyoucaneat == 1 &&
      settings.selfordering.enable_ayce_price_popup == 1 &&
      request.has_price == 1 &&
      !skip_alert
    ) {
      setAlertData({
        title: <Label number={102} />,
        message: <Label number={144} />,
        confirmMessage: <Label number={57} />,
        cancelMessage: <Label number={26} />,
        showCancelButton: true,
        callback: () => {
          add_product(request, true);
        },
      });
      return;
    }
    setFlowPopUp(false);
    request.mono_order = monoOrder;
    request.lang = lang;
    if (settings.selfordering.nicknames == 1)
      request.nickname = user ? user.name + " " + user.surname : cart.nickname;
    // nickname spenti: si segna comunque chi ha fatto accesso, per il conto del tavolo (chi ha ordinato cosa)
    else if (user) request.added_by = [user.name, user.surname].filter(Boolean).join(" ");
    if (singleOrderMode) request.user_id = userID;
    setLoading(true);
    const response = await Api.post("/self_cart/add_product/" + table.id + "/", request);
    if (response.success === 0) {
      setLoading(false);
      setAlertData({
        message: response.error,
        confirmMessage: <Label number={31} />,
      });
    } else {
      setSelectedProduct(false);
      setConfirmAnimation(true);
      if (settings.menu_api?.enable_related_products_on_cart_add == 1) {
        if (loadRelated) getRelatedProducts(getCartProductsIds(), request.product_id);
        else setRelatedProducts(false);
      }
    }
  };

  function checkCartQty(product) {
    console.log("checkCartQty");
    if (!isStockCheckEnabled()) return true;
    let cartQty = 0;
    for (const p of cart.products) {
      if (p.product_id == product.id) cartQty += parseInt(p.qty);
    }
    console.log(cartQty);
    if (cartQty < product.stock) return true;
    return false;
  }

  const getRelatedProducts = async (ids, id = null) => {
    console.log("getRelatedProducts", ids);
    const response = await Api.post("/related_products/get/", {
      ids: ids,
      id: id,
    });
    if (response.success === 0) {
      setAlertData({
        message: response.error,
        confirmMessage: <Label number={31} />,
      });
    } else {
      console.log(response);
      let res = [];
      for (const rpId of response.rows) {
        console.log(rpId);
        for (const course of categories) {
          for (const category of course.categories) {
            for (const product of category.products) {
              let p = JSON.parse(JSON.stringify(product));
              if (product.id == rpId) res.push(p);
            }
          }
        }
      }
      console.log(res);
      if (res.length > 0) setRelatedProducts(res);
      else setRelatedProducts(false);
    }
  };

  const updateQty = async (product_id, item_id, qty, price, _unused = false, nickname = null, currentRowQty = null, currentTotalQty = null) => {
    console.log("updateQty", user.id);
    // cart.products può contenere due righe con lo stesso item_id (riga scontata + clone a prezzo pieno per
    // limite sconto): find() ritorna sempre la prima, quindi per queste righe la qty "corrente" della riga
    // cliccata va passata esplicitamente dal chiamante (currentRowQty/currentTotalQty), non ridedotta qui.
    const p = cart.products.find((p) => p.item_id == item_id);
    const s = stock.find((s) => s.product_id == p.product_id && s.shop_id == shop.id);
    const currentNicknameQty = nickname
      ? parseInt((p.nicknames || []).find((row) => row.nickname === nickname)?.qty || 0)
      : parseInt(currentRowQty ?? p.qty);
    const totalQtyBase = parseInt(currentTotalQty ?? (p.qty_unsplitted ?? p.qty));
    const targetTotalQty = nickname
      ? parseInt(p.qty) - currentNicknameQty + parseInt(qty)
      : totalQtyBase - currentNicknameQty + parseInt(qty);
    if (
      !isStockCheckEnabled() ||
      targetTotalQty < totalQtyBase ||
      s === undefined ||
      parseInt(s.qty) >= targetTotalQty
    ) {
      setRelatedProducts(false);
      setLoading(true);
      const response = await Api.post("/self_cart/edit_product/" + table.id + "/?debug=1", {
        lang: lang,
        item_id: item_id,
        qty: nickname ? qty : targetTotalQty,
        nickname: nickname,
        mono_order: monoOrder,
        has_price: price > 0 ? 1 : 0,
      });
      if (response.success === 0) {
        setLoading(false);
        setAlertData({
          message: response.error,
          confirmMessage: <Label number={31} />,
        });
      } else {
        if (settings.menu_api?.enable_related_products_on_cart_add == 1) {
          if (loadRelated) getRelatedProducts(getCartProductsIds(), product_id);
          else setRelatedProducts(false);
        }
      }
    }
  };

  const getCartProductsIds = () => {
    let res = [];
    for (const product of cart.products) {
      res.push(product.product_id);
    }
    return res;
  };

  // Le righe scontate del carrello mostrato non devono superare la quantita' residua dello sconto (puo' essere finita nel frattempo):
  // in quel caso si ricarica il carrello, che il server ricalcola, e si avvisa il cliente prima del pagamento.
  const checkDiscountsBeforeCheckout = async () => {
    const products = (cart?.products || [])
      .filter((product) => product.discounted == 1 && product.discount?.discount_id)
      .map((product) => ({
        name: product.name,
        qty: product.qty,
        discounted: 1,
        discount: { category: product.discount.category, discount_id: product.discount.discount_id },
      }));
    if (products.length === 0) return true;
    const response = await Api.post("/products_stock/check_discounts_for_customers/", {
      shop_id: shop.id,
      lang: lang,
      products: products,
    });
    if (response && response.success == 0) {
      await loadCart();
      setAlertData({
        message: response.error,
        confirmMessage: <Label number={31} />,
      });
      return false;
    }
    return true;
  };

  const validateCartBeforeCheckout = async () => {
    setLoading(true);
    try {
      if (!(await checkDiscountsBeforeCheckout())) return false;
      const result = await checkProductsStockForCustomers();
      if (!result.ok) {
        if (result.errors.length > 0) {
          await loadCart();
          setAlertData({
            title: <Label number={154} />,
            message: buildCleanupMessage(result.errors),
            confirmMessage: <Label number={155} />,
            cancelMessage: <Label number={26} />,
            showCancelButton: true,
            callback: async () => {
              await cleanupInvalidCartProducts();
            },
          });
        }
        return false;
      }
      return true;
    } finally {
      setLoading(false);
    }
  };

  const hasSelforderingPaymentMethods = () => {
    const paymentMethods = [1, 2, 3, 8, 9, 11, 12];
    return paymentMethods.some(
      (paymentMethodId) => shop.payment_methods?.[paymentMethodId]?.active_selfordering == 1,
    );
  };

  const handleCheckout = async (skipRegistration = false) => {
    if (settings.selfordering.force_login == 1 && !user) {
      setUserPopupVisible(true);
      return;
    }
    if (
      monoOrder &&
      settings.selfordering.enable_email == 1 &&
      !cart.email &&
      !user &&
      !skipRegistration
    ) {
      setEmailPopupVisible(true);
      return;
    }
    checkPreorderPopups(() => proceedWithCheckout(skipRegistration));
  };

  const proceedWithCheckout = async (skipRegistration = false) => {
    console.log("handleCheckout", skipRegistration);
    const forcePaymentOnMultiOrder =
      !monoOrder && !singleOrderMode && settings.selfordering.enable_payment_mono == 1;
    const shouldOpenPaymentFlow =
      cart.total > 0 && (monoOrder || singleOrderMode || forcePaymentOnMultiOrder);

    if (
      shouldOpenPaymentFlow &&
      shop.yellgo_pay?.active_selforder != 1 &&
      hasSelforderingPaymentMethods()
    ) {
      const isOk = await validateCartBeforeCheckout();
      if (!isOk) return;
      setShowPaymentPopup(true);
    } else if (shouldOpenPaymentFlow && shop.yellgo_pay?.active_selforder == 1) {
      precheck_yellgo_pay();
    } else if (!monoOrder) {
      setAlertData({
        title: <Label number={49} />,
        message: <Label number={50} />,
        showCancelButton: true,
        callback: checkout,
      });
    } else {
      setAlertData({
        title: <Label number={103} />,
        message: <Label number={104} />,
        showCancelButton: true,
        callback: checkout,
      });
    }
  };

  const precheck_yellgo_pay = async () => {
    console.log("precheck_yellgo_pay");
    const isOk = await validateCartBeforeCheckout();
    if (!isOk) return;
    const paymentMethod1Active = shop.payment_methods?.[1]?.active_selfordering == 1;
    const paymentMethod2Active = shop.payment_methods?.[2]?.active_selfordering == 1;
    if (paymentMethod1Active || paymentMethod2Active) setShowYellgoPayPopup(true);
    else init_yellgo_pay();
  };

  async function checkout(paymentMethodId = null, payment_id = null) {
    console.log("checkout");
    const isOk = await validateCartBeforeCheckout();
    if (!isOk) return;
    setShowYellgoPayPopup(false);
    setLoading(true);

    const response = await Api.post("/self_cart/checkout/" + table.id + "/", {
      shop_id: shop.id,
      mono_order: monoOrder,
      payment_method_id: paymentMethodId,
      payment_id: payment_id,
      customer_id: user.id,
      brand_id: brand ? brand.id : null,
      user_id: userID,
      timer_active: timerActive ? true : false,
      self_mode: accessType,
      credit: credit,
      customer: {
        id: user.id,
        name: user.name,
        surname: user.surname,
        email: user.email,
        area_code: user.area_code,
        mobile: user.mobile,
        customer_lang: user.customer_lang,
      },
    });
    setLoading(false);
    if (response.success == 1) {
      closeCart(response.data);
    } else {
      setAlertData({
        message: response.error,
        confirmMessage: <Label number={31} />,
      });
    }
  }

  const closeCart = (order) => {
    if (newsletter == 1) editCustomer("newsletter");
    if (marketing == 1) editCustomer("marketing");

    setShowPaymentPopup(false);
    setCartVisible(false);
    setCredit(false);
    if (monoOrder) {
      setMonoOrderConfirmVisible(order);
    } else if (singleOrderMode) setQrOrderConfirmVisible(order);
    else
      setAlertData({
        message: <Label number={48} />,
        confirmMessage: <Label number={31} />,
      });
  };

  const init_yellgo_pay = async () => {
    console.log("init_yellgo_pay");
    const isOk = await validateCartBeforeCheckout();
    if (!isOk) return;
    setShowYellgoPayPopup(false);
    setLoading(true);
    const request = {
      mode: "single",
      shop_id: shop.id,
      amount: cart.total,
      origin: "selfordering",
      user_id: userID,
      customer_id: user.id,
      table_id: table.id,
      self_mode: accessType,
      lang: lang || "it",
      redirect_ko_url: document.location.href,
      data: {
        shop_id: shop.id,
        mono_order: monoOrder,
        customer_id: user.id,
        brand_id: brand ? brand.id : null,
        user_id: userID,
        timer_active: timerActive ? true : false,
        self_mode: accessType,
        credit: credit,
        customer: {
          id: user.id,
          name: user.name,
          surname: user.surname,
          email: user.email,
          area_code: user.area_code,
          mobile: user.mobile,
          customer_lang: user.customer_lang || lang || "it",
        },
      },
    };
    console.log(request);
    const response = await Api.post("/pay/open/" + table.id + "/", request);
    setLoading(false);
    console.log(response);
    if (response.success === 0) alert(response.error);
    else {
      console.log(response.url);
      document.location = response.url;
    }
  };

  const editCustomer = async (name) => {
    console.log("editCustomer");
    const response = await Api.postProtected("/customers/edit/" + user.id + "/", {
      [name]: 1,
    });
    console.log(response);
    if (response.success === 0)
      setAlertData({
        message: response.error,
        confirmMessage: <Label number={31} />,
      });
  };

  const applyCustomCss = () => {
    console.log("applyCustomCss");
    if (settings.selfordering) {
      var injectedStyles = document.createElement("style");
      injectedStyles.setAttribute("type", "text/css");
      injectedStyles.innerHTML = settings.selfordering.css;
      document.head.appendChild(injectedStyles);

      document.documentElement.style.setProperty("--c1", settings.selfordering.color1);
      document.documentElement.style.setProperty("--c1c", settings.selfordering.color2);
      document.documentElement.style.setProperty("--c1o", settings.selfordering.color1 + "50");
      document.documentElement.style.setProperty("--c2", settings.selfordering.color3);
      document.documentElement.style.setProperty("--c2c", settings.selfordering.color4);

      document.documentElement.style.setProperty(
        "--ch",
        settings.selfordering.color_logo1 ? settings.selfordering.color_logo1 : settings.selfordering.color1,
      );
      document.documentElement.style.setProperty(
        "--cho",
        settings.selfordering.color_logo2 ? settings.selfordering.color_logo2 : settings.selfordering.color2,
      );
    }
  };

  const applyBrandCss = () => {
    console.log("applyBrandCss");

    console.log("brand", brand);
    let newSettings = { ...settings };

    if (brand.img) newSettings.selfordering.logo = brand.img;

    for (const key in brand.settings.selfordering) {
      console.log(key, brand.settings.selfordering[key]);
      if (brand.settings.selfordering[key] != "")
        newSettings.selfordering[key] = brand.settings.selfordering[key];
    }

    document.documentElement.style.setProperty("--c1", newSettings.selfordering.color1);
    document.documentElement.style.setProperty("--c2", newSettings.selfordering.color2);
    document.documentElement.style.setProperty("--c3", newSettings.selfordering.color3);
    document.documentElement.style.setProperty("--c4", newSettings.selfordering.color4);
    document.documentElement.style.setProperty("--c1o", newSettings.selfordering.color1 + "10");

    document.documentElement.style.setProperty(
      "--ch",
      settings.selfordering.color_logo1 ? settings.selfordering.color_logo1 : settings.selfordering.color1,
    );
    document.documentElement.style.setProperty(
      "--cho",
      settings.selfordering.color_logo2 ? settings.selfordering.color_logo2 : settings.selfordering.color2,
    );

    setSettings(newSettings);
  };

  const getDefaultBrand = async (shopID, temp_settings) => {
    if (temp_settings.mandant.brands == 1) {
      console.log("getDefaultBrand");
      const response = await Api.post("/shops/get/" + shopID + "/");
      if (response.data.brands.length > 0) return response.data.brands[0].id;
    }
    return false;
  };

  const setDefaultCourse = () => {
    console.log("setDefaultCourse");
    if (categories.length > 0) {
      setCourse(categories[0]);
      if (categories[0].categories.length > 0 && settings.selfordering.hide_home == 1)
        setCategory(categories[0].categories[0]);
    }
  };

  const initTablePayment = () => {
    setAlertData({
      title: <Label number={102} />,
      message: <Label number={122} />,
      showCancelButton: true,
      callback: async () => {
        // conto tavolo: l'importo lo calcola l'API dagli ordini aperti del tavolo
        const response = await Api.post("/pay/open/", {
          mode: "table",
          origin: "selfordering",
          table_id: table.id,
          shop_id: shop.id,
          self_cart_id: cart.cart_id,
          customer_id: user.id,
          self_mode: accessType,
          // il conto si apre nella lingua del selforder
          lang: lang || "it",
        });
        if (response.success == 1) document.location = response.url;
        else alert(response.error);
      },
    });
  };

  const check_round_time = () => {
    console.log("check_round_time");
    if (cart.last_order) {
      var formatted_date = replaceAll(cart.last_order.delivery_date, "-", "/");
      const d = new Date();
      const d2 = new Date(formatted_date);
      var diff = d - d2;
      var remaining = shop.selfordering_round_time * 60000 - diff;
      var remaining_min = Math.floor(remaining / 60000);
      var remaining_sec = ((remaining % 60000) / 1000).toFixed(0);
      remaining_sec = remaining_sec < 10 ? "0" + remaining_sec : remaining_sec;
      var remaining_formatted = remaining_min + ":" + remaining_sec;
      //console.log("Actual time", d);
      //console.log("Last order time", d2);
      //console.log("Diff", diff);
      //console.log("Remaining min", remaining_min);
      //console.log("Remaining sec", remaining_sec);
      //console.log("remaining", remaining);
      //console.log("remaining_formatted", remaining_formatted);
      if (remaining <= 0) {
        setTimerActive(false);
        //clearInterval(timer);
      } else setTimerActive(remaining_formatted);
    }
  };

  const open_temp_cart = async (shop_id, name) => {
    console.log("open_temp_cart");
    const tableID = userID;
    console.log(tableID);
    const response = await Api.post("/self_cart/open_temp_cart/" + tableID + "/", {
      shop_id: shop_id,
      name: name,
    });
    if (response.success === 0) alert(response.error);
    else {
      setTable({
        id: tableID,
      });
      setPin(tableID);
    }
  };

  const resume_temp_cart = async (shop_id) => {
    const tableID = userID;

    const response = await Api.post("/self_cart/get/" + tableID + "/", {
      mono_order: true,
      lang: lang,
      customer_id: user?.id,
      shop_id: shop_id,
      user_id: userID,
      brand_id: brand ? brand.id : "",
      credit: credit,
    });

    if (response.success !== 1) {
      return false;
    }

    setTable({
      id: tableID,
    });
    setPin(tableID);
    return true;
  };

  // --- modalità tablet (YELLGO-6125) ---
  const tabletReset = () => {
    localStorage.removeItem(scopedStorageKey("tablet_table"));
    localStorage.removeItem(scopedStorageKey("pin"));
    setPin(false);
    setTable(false);
    setCart(false);
    setStaff(false);
    setStaffGateVisible(false);
    setTabletWelcome(false);
    setAlertData(false);
  };

  // l'operatore ha scelto/aperto il tavolo: il tablet passa al cliente e la sezione operatore si blocca
  const tabletEnterTable = (tableId) => {
    localStorage.setItem(scopedStorageKey("tablet_table"), tableId);
    localStorage.setItem(scopedStorageKey("pin"), "not_required");
    setPin("not_required");
    setStaff(false);
    setStaffGateVisible(false);
    setTabletWelcome(true);
  };

  // dal cliente si torna alla lista tavoli solo dopo un nuovo PIN operatore (staff valorizzato dal StaffPin)
  useEffect(() => {
    if (tabletMode && staff && pin) {
      localStorage.removeItem(scopedStorageKey("tablet_table"));
      localStorage.removeItem(scopedStorageKey("pin"));
      setPin(false);
      setTable(false);
      setCart(false);
      setStaffGateVisible(false);
      setTabletWelcome(false);
    }
  }, [staff]);

  const router = () => {
    //console.log("router", monoOrder, shop, table, cart.covers, pin);
    if (tabletMode && !pin) return staff ? <StaffTablesFrame /> : <StaffPin />;
    if (tabletMode && pin && tabletWelcome && table) return <TabletWelcome />;
    if (!pin) {
      if (monoOrder) return <Name />;
      else return <Pin />;
    } else if (
      table &&
      (!cart.covers || parseInt(cart.covers) == 0) &&
      settings.selfordering.disable_covers == 0
    )
      return <Covers />;
    else if (settings.selfordering.enable_customer_select_list == 1 && !table.list_id) return <Lists />;
    else return <Page />;
  };

  if (lock) return <Loading />;

  return (
    <GoogleOAuthProvider clientId={settings.google?.client_id}>
      <SettingsContext.Provider
        value={{
          settings,
          setSettings,
          lang,
          setLang,
          accessType,
          monoOrderConfirmVisible,
          setMonoOrderConfirmVisible,
          isPaymentUser,
          setIsPaymentUser,
          legal,
          setLegalPupop,
          setPagePopup,
          category,
          setCategory,
          course,
          setCourse,
          setIsClosed,
          credit,
          setCredit,
          load_menu,
          onDiscountsProductsEvent,
          reloadDiscountsAvailability,
          loadCart,
          loadSettings,
          editTable,
          labels,
          setLabels,
          userID,
          cartVisible,
          setCartVisible,
          userPopupVisible,
          setUserPopupVisible,
          selectedProduct,
          setSelectedProduct,
          setPromoPopup,
          setProductSheet,
          qrOrderConfirmVisible,
          setQrOrderConfirmVisible,
          discounts,
          setLoading,
          setOrdersVisible,
          initTablePayment,
          relatedProducts,
          setRelatedProducts,
          popUps,
          getRelatedProducts,
          setLoadRelated,
          timerActive,
          setTimerActive,
          monoOrder,
          setEmailPopupVisible,
          editCart,
          handleCheckout,
          showPaymentPopup,
          setShowPaymentPopup,
          showYellgoPayPopup,
          setShowYellgoPayPopup,
          checkout,
          init_yellgo_pay,
          closeCart,
          marketing,
          setMarketing,
          newsletter,
          setNewsletter,
          singleOrderMode,
          open_temp_cart,
          resume_temp_cart,
          productNotesPopup,
          setProductNotesPopup,
          pin,
          setPin,
          pages,
          loadProductsStock,
          validateCartBeforeCheckout,
          handleAddProduct,
          setQrPopupVisible,
          setCategoryHandler,
          limits,
          setLocalHistoryVisible,
          history,
          setHistory,
          additionalCheckoutFields,
          scopedStorageKey,
          tabletMode,
          staff,
          setStaff,
          setStaffGateVisible,
          setTabletWelcome,
          tabletEnterTable,
        }}
      >
        <ShopContext.Provider value={{ shop, setShop, load_shop, brand }}>
          <TableContext.Provider value={{ table, setTable, load_table }}>
            <CategoriesContext.Provider
              value={{
                categories,
                setCategories,
              }}
            >
              <CartContext.Provider value={{ cart, setCart, add_product, updateQty }}>
                <AlertContext.Provider value={{ alertData, setAlertData }}>
                  <UserContext.Provider value={{ user, setUser, load_customer }}>
                    {settings && shop && table && <Socket socket={socket} />}
                    {router()}

                    {cart.allyoucaneat == 1 && table && <Limits />}
                    {ordersVisible && <Orders setOrdersVisible={setOrdersVisible} />}
                    {cartVisible && <Cart cartVisible={cartVisible} setCartVisible={setCartVisible} />}
                    {userPopupVisible && (
                      <User data={userPopupVisible} setUserPopupVisible={setUserPopupVisible} />
                    )}
                    {emailPopupVisible && <EmailPopup data={userPopupVisible} />}
                    {relatedProducts && <RelatedProductsPopup />}
                    {productSheet && <ProductSheet product={productSheet} />}
                    {selectedProduct && <Variants product={selectedProduct} />}
                    {legalPopup && <LegalPopup content={legalPopup} />}
                    {pagePopup && <PagePopup id={pagePopup} />}
                    {localHistoryVisible && <LocalHistory />}
                    {promoPopup && <PromoPopup />}
                    {flowPopUp && (
                      <FlowPopUp data={flowPopUp} add_product={add_product} settings={settings} />
                    )}
                    {alertData && <Alert alertData={alertData} setAlertData={setAlertData} />}
                    {preorderPopup && <PreorderPopup data={preorderPopup} lang={lang} />}
                    {confirmAnimation && (
                      <div className="confirm">
                        <div>
                          <Label number={16} />
                        </div>
                      </div>
                    )}
                    {monoOrderConfirmVisible && (
                      <MonoOrderConfirm onClose={() => setMonoOrderConfirmVisible(false)} />
                    )}
                    {qrOrderConfirmVisible && (
                      <QrOrderConfirm
                        order={qrOrderConfirmVisible}
                        onClose={() => setQrOrderConfirmVisible(false)}
                      />
                    )}
                    {qrPopupVisible && (
                      <>
                        <div className="overlay" onClick={() => setQrPopupVisible(false)}></div>
                        <QrPopup />
                      </>
                    )}
                    {tabletMode && pin && staffGateVisible && (
                      <StaffPin onCancel={() => setStaffGateVisible(false)} />
                    )}
                    {loading && <Loading />}
                    {isClosed && <Lock message={isClosed} />}
                    {isMaintenance && <Lock message={isMaintenance} />}
                    {settings && settings.mandant.expired && (
                      <div className="expire">
                        <div className="content">
                          <h3>ATTENZIONE</h3>
                          Servizio non attivo
                        </div>
                      </div>
                    )}
                    {/* popup promo nascosti (non smontati, per non perdere quelli già chiusi) sulle schermate operatore/PIN */}
                    <PopUps hidden={tabletMode && (!pin || staffGateVisible)} />
                  </UserContext.Provider>
                </AlertContext.Provider>
              </CartContext.Provider>
            </CategoriesContext.Provider>
          </TableContext.Provider>
        </ShopContext.Provider>
      </SettingsContext.Provider>
    </GoogleOAuthProvider>
  );
}

export default App;
